import React from "react";
import {
  Box,
  makeStyles,
  Typography,
} from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  errorMessage: {
    fontSize: theme.typography.h6.fontSize,
    whiteSpace: 'pre-line',
  },
}));

export interface ISignInErrorHandlerProps {
  error: Error;
}

export const SignInErrorHandler: React.FC<ISignInErrorHandlerProps> = (props: ISignInErrorHandlerProps) => {
  const ComponentName='SignInErrorHandler';

  const classes = useStyles();

  let title = 'Sign-in Failed';
  let message = `Oops. Something went wrong.\n Please contact your system administrator.`;


  console.log(`${ComponentName}: props = ${JSON.stringify(props.error.name, null, 2)}`);

  switch (props.error.name) {
    case 'AuthenticationError':
      title = 'Session Expired';
      message = 'Your session has expired. Please sign-in again.';
      break;
    case 'NotActivatedError':
      title = 'Account Activation Pending';
      message = `
        Your account must be activated before you can access this system.
        You will receive an email when activation is completed.
      `;
      break;
    case 'NotAllowedError':
      title = 'Access Denied';
      message = `
        You don't have access to this system.
        Please contact your system administrator to request access.
      `;
      break;
    case 'EpDevPServiceUnavailableError':
      title = 'Service Temporarily Unavailable';
      message = `
        Please try again later or contact your system administrator.
      `;
      break;
    default:
      break;
  }
    
  const renderContent = () => {
    return (
      <Box display="flex" justifyContent="center">
        <Box mt={10}>
          <Box mb={2} textAlign="center">
            <Typography variant="h2">{title}</Typography>
          </Box>
          <Box textAlign="center">
            <Typography className={classes.errorMessage} variant="body1">
              {message}
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  }
  return (
    <>
      { renderContent() }
    </>
  );
}
